import { createAction } from "redux-actions";
import { ACTUAL_PAGE } from "../constants";

export const setActualPage = createAction(ACTUAL_PAGE, (title) => ({ title }) )